import { render, staticRenderFns } from "./fullReduction.vue?vue&type=template&id=c136f228&scoped=true&"
import script from "./fullReduction.vue?vue&type=script&lang=js&"
export * from "./fullReduction.vue?vue&type=script&lang=js&"
import style0 from "./fullReduction.vue?vue&type=style&index=0&id=c136f228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c136f228",
  null
  
)

export default component.exports